<script lang="ts">
    
    import { onMount, SvelteComponent } from "svelte";
    import type { ImageContentDto, InfoContent, TextContentDto } from "../../global";
    import ImageContent from "./ImageContent.svelte";
    import TextContent from "./TextContent.svelte";

    export let content: InfoContent;

    let component: typeof SvelteComponent;

    onMount(() => {
        if (isTextContent(content)) {
            component = TextContent;
        } else if (isImageContent(content)) {
            component = ImageContent;
        }
    });

    function isTextContent(content: InfoContent): content is TextContentDto {
        return 'text' in content;
    }

    function isImageContent(content: InfoContent): content is ImageContentDto {
        return 'image' in content;
    }

</script>

<svelte:component this={component} {content} />
